import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { createReactEditorJS } from 'react-editor-js';
import blocksToArticle from '../utils/blocks-to-article';
import { EDITOR_JS_TOOLS } from './tools';
import ReadOnly from './readOnly';
var ReactEditorJS = createReactEditorJS();

function Editor(_ref) {
  var _ref$blocks = _ref.blocks,
      blocks = _ref$blocks === void 0 ? [] : _ref$blocks,
      onChange = _ref.onChange,
      imageIndex = _ref.imageIndex,
      selectedFrame = _ref.selectedFrame;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var handleChange =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(instance) {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return instance.saver.save();

            case 2:
              data = _context.sent;
              onChange({
                imageIndex: imageIndex,
                data: data
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var toggleEditMode = function toggleEditMode() {
    setEditMode(function (prev) {
      return !prev;
    });
  };

  if (blocks.length < 1) {
    return React.createElement("div", {
      className: "instructions"
    }, React.createElement("h1", null, "Click article to display text."));
  }

  return React.createElement("div", null, React.createElement("div", {
    className: "show-metadata-wrapper"
  }, React.createElement("label", {
    className: "switch mr-2"
  }, React.createElement("input", {
    id: "show-metadata",
    type: "checkbox",
    value: editMode,
    onChange: toggleEditMode
  }), React.createElement("span", {
    className: "slider round"
  })), React.createElement("label", null, "Edit mode")), !editMode ? React.createElement(ReadOnly, {
    article: blocksToArticle(blocks)
  }) : React.createElement(ReactEditorJS, {
    defaultValue: {
      blocks: blocks
    },
    tools: EDITOR_JS_TOOLS,
    onChange: handleChange,
    enableReInitialize: true,
    key: selectedFrame
  }));
}

export default Editor;